var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFindDoctors(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.7 17.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#fff;}.cls-1,.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:0.54px;}.cls-2{stroke-width:0.7px;}.cls-3{stroke-miterlimit:10;stroke-width:0.45px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.03 5.03 5.03 3.6 6.94 3.6 6.94 5.03 8.37 5.03 8.37 6.94 6.94 6.94 6.94 8.37 5.03 8.37 5.03 6.94 3.6 6.94 3.6 5.03 5.03 5.03"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 5.99,
    cy: 5.99,
    r: 5.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.17,17.61a1.1,1.1,0,0,1-.76-.53L8.76,10.87l.9-.62,4.56,5.56a1.11,1.11,0,0,1-1.05,1.8Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindDoctors);
export default __webpack_public_path__ + "static/media/findDoctors.49caaff6bbfafa30a4707c55386c724d.svg";
export { ForwardRef as ReactComponent };